<template lang="html">
  <div class="topbar">
    <div id="innopearl_topbar">
      <div class="topbar_left">
        <div class="pageTitle" v-if="$store.state.page.mainTitle">
          <span class="mainTitle">{{ $store.state.page.mainTitle }} </span>
          <span v-if="$store.state.page.subTitle" class="subTitle">{{ $store.state.page.subTitle }}</span>
        </div>
      </div>

      <div class="topbar_right">
        <router-link
          v-if="droit_access_platform != 'full'"
          class="secondary-action-button"
          to="/upgrade_your_plan"
        >
          Upgrade
        </router-link>

        <div class="new_btn_wrapper" v-click-outside="closeNewDropdown">
          <button class="primary-action-button" :class="{ open: isNewOpen, 'new_btn--gold': droit_access_platform == 'full' }" @click="toggleNew">
            <span>New</span>
            <SvgIcon name="plus" :size="20" />
          </button>
          <div v-if="isNewOpen" class="new_dropdown">
            <button
              v-for="option in newOptions"
              :key="option.id"
              class="new_dropdown_item"
              :class="{ disabled: option.disabled }"
              :disabled="option.disabled"
              @click="selectNewOption(option)"
            >
              <span class="dropdown_icon"><SvgIcon :name="option.icon" :size="16" /></span>
              <span>{{ option.label }}</span>
              <SvgIcon v-if="option.disabled" name="lock" :size="12" class="dropdown_lock" />
            </button>
          </div>
        </div>

        <div
          class="topbar_widget"
          :class="{ 'tooltip-open': aiTooltipOpen }"
          @mouseenter="aiTooltipOpen = true"
          @mouseleave="aiTooltipOpen = false"
        >
          <div class="widget_icon widget_icon_blue">
            <SvgIcon name="sparkles" :size="20" />
          </div>
          <div class="widget_text">
            <span class="widget_label">AI Credits</span>
            <span class="widget_value">
              {{ creditAi }}
            </span>
          </div>
          <SvgIcon
            name="info"
            :size="16"
            class="widget_info"
            @click.stop="aiTooltipOpen = !aiTooltipOpen"
          />
          <div class="widget_tooltip">
            <p class="tooltip_title">How AI credits work</p>
            <ul class="tooltip_list">
              <li>1 credit = 1 AI activation</li>
              <li>4 – 5 credits for opportunity generation and solution discovery</li>
              <li>Credits renew monthly or annually based on your plan</li>
            </ul>
          </div>
        </div>

        <router-link
          to="/pearlai_dataroom"
          class="topbar_widget topbar_widget--link"
          :class="{ 'tooltip-open': dataroomTooltipOpen }"
          @mouseenter="dataroomTooltipOpen = true"
          @mouseleave="dataroomTooltipOpen = false"
        >
          <div class="widget_icon widget_icon_neutral">
            <SvgIcon name="database" :size="20" />
          </div>
          <div class="widget_text">
            <span class="widget_label">Data Room</span>
            <span class="widget_value">
              {{ dataroomSize }}
              <span class="widget_max">files</span>
            </span>
          </div>
          <SvgIcon
            name="info"
            :size="16"
            class="widget_info"
            @click.stop.prevent="dataroomTooltipOpen = !dataroomTooltipOpen"
          />
          <div class="widget_tooltip">
            <p class="tooltip_title">File upload</p>
            <div class="tooltip_body">
              <p>Upload files that explain your business or market context.</p>
              <p>AI processing is secured. Your data is not shared or used for model training.</p>
            </div>
          </div>
        </router-link>

        <router-link to="/myaccount" class="user_profile">
          <div class="user_text">
            <span class="user_name">{{ fullname }}</span>
            <!-- <span class="user_role">{{ userRoleLabel }}</span> -->
          </div>
          <div class="user_avatar">
            <img
              v-if="customerlogo && customerlogo !== 'null'"
              :src="apiUrl + '/get_image/' + customerlogo + '?token=' + innotoken"
              alt=""
            />
            <img
              v-else
              :src="require('@/assets/header_my_account.svg')"
              alt=""
            />
          </div>
        </router-link>
      </div>
    </div>

    <div id="topbar_responsive">
      <div class="topbar_mobile_inner">
        <div class="pageTitle" v-if="$store.state.page.mainTitle">
          <span class="mainTitle">{{ $store.state.page.mainTitle }}</span>
          <span v-if="$store.state.page.subTitle" class="subTitle">{{ $store.state.page.subTitle }}</span>
        </div>
        <img
          v-else
          :src="require('@/assets/images/logo-simple.png')"
          class="small_topbar_logo"
          alt=""
        />
        <div class="new_btn_wrapper new_btn_wrapper--mobile">
          <button class="primary-action-button" :class="{ open: isNewOpen, 'new_btn--gold': droit_access_platform == 'full' }" @click.stop="toggleNew">
            <span>New</span>
            <SvgIcon name="plus" :size="20" />
          </button>
        </div>
        <router-link to="/myaccount" class="user_avatar_mobile">
          <img
            v-if="customerlogo && customerlogo !== 'null'"
            :src="apiUrl + '/get_image/' + customerlogo + '?token=' + innotoken"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/header_my_account.svg')"
            alt=""
          />
        </router-link>
      </div>
      <Teleport to="body">
        <div v-if="isNewOpen" class="new_dropdown_overlay_mobile" @click.self="closeNewDropdown">
          <div class="new_dropdown new_dropdown--mobile">
            <button
              v-for="option in newOptions"
              :key="option.id"
              class="new_dropdown_item"
              :class="{ disabled: option.disabled }"
              :disabled="option.disabled"
              @click="selectNewOption(option)"
            >
              <span class="dropdown_icon"><SvgIcon :name="option.icon" :size="16" /></span>
              <span>{{ option.label }}</span>
            </button>
          </div>
        </div>
      </Teleport>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { mapState, mapGetters } from "vuex";

const clickOutside = {
  beforeMount(el, binding) {
    el.__clickOutsideHandler__ = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener("click", el.__clickOutsideHandler__);
  },
  unmounted(el) {
    document.removeEventListener("click", el.__clickOutsideHandler__);
  },
};

export default {
  name: "TopBar",
  components: { SvgIcon },
  directives: { "click-outside": clickOutside },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isNewOpen: false,
      aiTooltipOpen: false,
      dataroomTooltipOpen: false,
    };
  },
  computed: {
    ...mapState([
      "role",
      "fullname",
      "myProjects",
      "customerlogo",
      "innotoken",
      "droit_access_platform",
      "pearlAICredit",
      "rankAICredit",
      "dataroomSize",
    ]),
    creditAi() {
      return (this.pearlAICredit || 0) + (this.rankAICredit || 0);
    },
    ...mapGetters({ locks: "featureLocks" }),
    userRoleLabel() {
      if (this.droit_access_platform === "full") return "Premium Member";
      if (this.role) return this.role;
      return "";
    },
    newOptions() {
      return [
        { id: "challenge", label: "Challenge", icon: "compass", to: "/where_to_innovate_finder", disabled: this.locks.discover },
        { id: "project", label: "Project", icon: "briefcase", to: "/selectYourChallenge", disabled: this.locks.discover },
        { id: "scouting", label: "Scouting Campaign", icon: "rocket", to: "/link_plus", disabled: this.locks.scout },
        { id: "assessment", label: "Assessment", icon: "fileText", to: "/internalassessment_creation", disabled: this.locks.assess },
      ];
    },
  },
  mounted() {
    this.$store.dispatch('fetchDataroom');
  },
  methods: {
    toggleNew() {
      this.isNewOpen = !this.isNewOpen;
    },
    closeNewDropdown(event) {
      // Ignore clicks that originate from the mobile button or the mobile dropdown
      // (the desktop wrapper's click-outside fires for these clicks because they are
      // outside the desktop wrapper, even though they belong to the same logical menu).
      if (event && event.target && event.target.closest) {
        if (
          event.target.closest('.new_btn_wrapper--mobile') ||
          event.target.closest('.new_dropdown--mobile') ||
          event.target.closest('.new_dropdown_overlay_mobile')
        ) {
          return;
        }
      }
      this.isNewOpen = false;
    },
    selectNewOption(option) {
      if (option.disabled) return;
      this.isNewOpen = false;
      if (option.to) this.$router.push(option.to);
    },
  },
};
</script>

<style media="screen" scoped>
#innopearl_topbar {
  height: 72px;
  background: #FFFFFF;
  border-bottom: 1px solid #E5E7EB;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  position: sticky;
  top: 0;
  z-index: 30;
}

.topbar_left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.topbar_right {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
}

.pageTitle {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.mainTitle {
  font-family: var(--font-title) !important;
  font-weight: 500 !important;
  font-size: var(--font-size-main-title, 24px) !important;
  line-height: 1.2 !important;
  color: var(--color-dark-blue) !important;
}
.mainTitle::first-letter { text-transform: uppercase; }
.subTitle {
  font-family: var(--font-title) !important;
  font-weight: 500 !important;
  font-size: var(--font-size-card, 16px) !important;
  line-height: 1.3 !important;
  color: var(--color-dark-blue) !important;
}
.subTitle::first-letter { text-transform: uppercase; }

.new_btn_wrapper {
  position: relative;
}
.new_btn_wrapper .primary-action-button.new_btn--gold,
.new_btn_wrapper .primary-action-button.new_btn--gold:focus,
.new_btn_wrapper .primary-action-button.new_btn--gold:visited{
  background: #D5A029 !important;
  color: #001D41 !important;
  border-color: #D5A029 !important;
  opacity: 1 !important;
  filter: none;
  transition: filter 0.15s ease, background 0.15s ease;
}
.new_btn_wrapper .primary-action-button.new_btn--gold:hover:not(:disabled),
.new_btn_wrapper .primary-action-button.new_btn--gold:active,
.new_btn_wrapper .primary-action-button.new_btn--gold.open{
  background: #D5A029 !important;
  color: #001D41 !important;
  border-color: #D5A029 !important;
  opacity: 1 !important;
  filter: brightness(1.05) !important;
}

.new_dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 224px;
  background: #FFFFFF;
  border: 1px solid #F1F5F9;
  border-radius: var(--radius-lg);
  padding: 8px 0;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  z-index: 50;
  overflow: hidden;
}
.new_dropdown_item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: transparent;
  border: none;
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  font-weight: 700;
  color: #334155;
  cursor: pointer;
  text-align: left;
  transition: background-color var(--transition-base);
}
.new_dropdown_item:hover:not(.disabled) {
  background-color: rgba(19, 57, 103, 0.05);
}
.new_dropdown_item:hover:not(.disabled) .dropdown_icon {
  background: var(--color-dark-blue);
  color: #FFFFFF;
}
.new_btn_wrapper:has(.new_btn--gold) .new_dropdown_item:hover:not(.disabled){
  background-color: rgba(213, 160, 41, 0.10);
}
.new_btn_wrapper:has(.new_btn--gold) .new_dropdown_item:hover:not(.disabled) .dropdown_icon{
  background: #D5A029;
  color: #001D41;
}
.new_dropdown_item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.dropdown_lock {
  margin-left: auto;
  color: rgba(19, 57, 103, 0.5);
  flex-shrink: 0;
}
.dropdown_icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  background: rgba(19, 57, 103, 0.1);
  color: var(--color-dark-blue);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color var(--transition-base), color 0.2s ease;
}

.topbar_widget {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
  min-height: 44px;
  color: var(--color-dark-blue);
  position: relative;
}
.topbar_widget--link,
.topbar_widget--link:hover{
  text-decoration: none;
  color: var(--color-dark-blue);
  cursor: pointer;
  border-radius: var(--radius-sm);
  padding: 4px 8px;
  transition: background-color var(--transition-base);
}
.topbar_widget--link:hover{
  background-color: rgba(19, 57, 103, 0.04);
}
.widget_tooltip {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 288px;
  padding: 20px;
  background: var(--color-white);
  color: var(--color-dark-blue);
  border: 1px solid rgba(19, 57, 103, 0.1);
  border-radius: var(--radius-lg);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  font-family: var(--font-body);
  font-size: var(--font-size-xsmall);
  line-height: 1.5;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity var(--transition-base), visibility 0.2s ease;
  z-index: 50;
}
.topbar_widget.tooltip-open .widget_tooltip {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}
.widget_tooltip::before {
  content: "";
  position: absolute;
  bottom: 100%;
  right: 16px;
  border: 8px solid transparent;
  border-bottom-color: var(--color-white);
}
.tooltip_title {
  margin: 0 0 12px 0;
  font-weight: 900;
letter-spacing: 0.5px;
  color: var(--color-dark-blue);
}
.tooltip_list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tooltip_list li {
  position: relative;
  padding-left: 14px;
  font-weight: 500;
}
.tooltip_list li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: 0;
}
.tooltip_body {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: 500;
}
.tooltip_body p {
  margin: 0;
}
.widget_icon {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.widget_icon_blue {
  background: rgba(57, 129, 195, 0.1);
  color: var(--color-dark-blue);
}
.widget_icon_neutral {
  background: #F1F5F9;
  color: var(--color-dark-blue);
}
.widget_text {
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: 1;
}
.widget_label {
  font-family: var(--font-body);
  font-size: var(--font-size-xsmall);
  font-weight: 400;
  letter-spacing: 0.5px;
  color: rgba(19, 57, 103, 0.6);
}
.widget_value {
  font-family: var(--font-body);
  font-size: var(--font-size-card);
  font-weight: 600;
  color: var(--color-dark-blue);
}
.widget_max {
  font-weight: 500;
  color: var(--color-dark-blue);
}
.widget_info {
  color: rgba(19, 57, 103, 0.3);
  margin-left: 4px;
  cursor: help;
  flex-shrink: 0;
}
.widget_info:hover {
  color: var(--color-dark-blue);
}

.user_profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 24px;
  border-left: 1px solid #E5E7EB;
  text-decoration: none;
  cursor: pointer;
}
.user_text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
  line-height: 1.2;
}
.user_name {
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  font-weight: 700;
  color: var(--color-dark-blue);
}
.user_role {
  font-family: var(--font-body);
  font-size: var(--font-size-xsmall);
  font-weight: 400;
  color: var(--color-dark-blue);
}
.user_avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #E2E8F0;
  border: 1px solid #CBD5E1;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user_avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 3px;
  box-sizing: border-box;
  background: #FFFFFF;
}

#topbar_responsive {
  display: none;
}

.topbar_mobile_inner {
  height: 64px;
  padding: 0 16px;
  background: #FFFFFF;
  border-bottom: 1px solid #E5E7EB;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.topbar_mobile_inner .pageTitle {
  flex: 1;
  min-width: 0;
}
.topbar_mobile_inner .mainTitle {
  font-size: var(--font-size-section, 20px) !important;
  line-height: 1.2 !important;
}
.topbar_mobile_inner .subTitle {
  font-size: var(--font-size-small, 13px) !important;
  line-height: 1.3 !important;
}
.small_topbar_logo {
  height: 32px;
  width: auto;
}
.user_avatar_mobile {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #E2E8F0;
  border: 1px solid #CBD5E1;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user_avatar_mobile img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 3px;
  box-sizing: border-box;
  background: #FFFFFF;
}

.new_btn_wrapper--mobile { display: none; }

.new_dropdown_overlay_mobile {
  position: fixed;
  inset: 0;
  background: rgba(19, 57, 103, 0.35);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.new_dropdown_overlay_mobile .new_dropdown--mobile {
  position: static;
  width: min(90vw, 320px);
  background: #FFFFFF;
  border: 1px solid #F1F5F9;
  border-radius: var(--radius-lg);
  padding: 8px 0;
  box-shadow: var(--shadow-modal);
}

@media screen and (max-width: 1200px) {
  #innopearl_topbar { display: none; }
  #topbar_responsive { display: block; position: sticky; top: 0; z-index: 30; }
  .new_btn_wrapper--mobile { display: block; }
  .new_dropdown_overlay_mobile { display: flex; }
}
</style>
